import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { L } from "@/i18n";

export const useUpdateQuestion = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, changes }) => api.put(`/questions/${id}`, changes),
    onSuccess: () => {
      toast.success(L("Question updated.", "Pergunta atualizada."));
      qc.invalidateQueries({ queryKey: ["questions"] });
      qc.invalidateQueries({ queryKey: ["duplicates"] });
    },
    onError: (e) => toast.error(L("Failed to update question: {e}", "Falha ao atualizar pergunta: {e}", { e: errorMessage(e) })),
  });
};

export const PAGE_SIZE = 20;

export const useQuestions = ({ module, search, page }) =>
  useQuery({
    queryKey: ["questions", module, search, page],
    queryFn: async () => {
      const params = { skip: (page - 1) * PAGE_SIZE, limit: PAGE_SIZE };
      if (module !== "all") params.module_title = module;
      if (search) params.search = search;
      const { data } = await api.get("/questions", { params });
      return Array.isArray(data) ? data : data?.questions ?? [];
    },
    placeholderData: keepPreviousData,
  });
